export const TUTORIALS_RECEIVED = "TUTORIALS_RECEIVED";
export const SET_SINGLE_TUTORIAL = "SET_SINGLE_TUTORIAL";
